import { render, staticRenderFns } from "./vipTools.vue?vue&type=template&id=42b49d56&scoped=true&"
import script from "./vipTools.vue?vue&type=script&lang=js&"
export * from "./vipTools.vue?vue&type=script&lang=js&"
import style0 from "./vipTools.vue?vue&type=style&index=0&id=42b49d56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b49d56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42b49d56')) {
      api.createRecord('42b49d56', component.options)
    } else {
      api.reload('42b49d56', component.options)
    }
    module.hot.accept("./vipTools.vue?vue&type=template&id=42b49d56&scoped=true&", function () {
      api.rerender('42b49d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/vipTools.vue"
export default component.exports